import React, { useEffect }  from 'react';
import { useNavigate }        from 'react-router-dom';
import { useAuth }            from '../context/AuthContext';
import { useTranslation }     from 'react-i18next';
import CircularProgress       from '@mui/material/CircularProgress';
import Box                    from '@mui/material/Box';
import Typography             from '@mui/material/Typography';

export default function Logout() {
    const { logout } = useAuth();
    const navigate   = useNavigate();
    const { t }      = useTranslation();

    useEffect(() => {
        const performLogout = async () => {
            try { await logout(); } catch (err) { console.error("Logout error:", err); }
            finally { window.location.href = '/'; }
        };
        performLogout();
    }, [logout, navigate]);

    return (
        <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', gap: 3 }}>
            <CircularProgress />
            <Typography variant="h6">{t('common.logging_out')}</Typography>
        </Box>
    );
}